const url_teste = "reglifecreditos.royalpag.com";

export default {
  getLogoMenu: function() {
    var url = (url_teste == "") ? window.location.href : url_teste;
    if (url.includes("reglifecreditos.royalpag.com")) {
      return { default: "/static/img/reglife_white.png", icon: this.iconStyleDefault(), homeLogo: "/static/img/reglife_white.png" }
    } 
    else {
      return { default: "/static/img/logo-default-app.png", icon: this.iconStyleDefault(), homeLogo: "/static/img/logo-transparent.png" }      
    }

  },
  getLogo: function() {

    var url = (url_teste == "") ? window.location.href : url_teste;

    if (url.includes("app.royalpag.com")) {
      return { default: "/static/img/logo-default-app.png", icon: this.iconStyleDefault(), homeLogo: "/static/img/logo-transparent.png" }
    }  
    else if (url.includes("royalsportbank.royalpag.com")) {
      return { default: "/static/img/logo-default.png", icon: this.iconStyleSport(), homeLogo: "/static/img/logo-transparent-sport.png" }
    } 
    else if (url.includes("gestaodebanca.royalpag.com")) {
      return { default: "/static/img/logo-default-gestao.png", icon: this.iconStyleBanca(), homeLogo: "/static/img/logo-transparent-banca.png" }
    } 
    else if (url.includes("reglifecreditos.royalpag.com")) {
      return { default: "/static/img/reglife.png", icon: this.iconStyleDefault(), homeLogo: "/static/img/reglife.png" }
    } 
    else {
      return { default: "/static/img/logo-default-app.png", icon: this.iconStyleDefault(), homeLogo: "/static/img/logo-transparent.png" }      
    }
  },
  getColorBackGround: function() {
    var url = (url_teste == "") ? window.location.href : url_teste;

    if (url.includes("reglifecreditos.royalpag.com")) {

      return {
        'background-color' : "#000 !important",
      }
    } 
    else {
      
      return {
        'border-color': "#224c85 !important"
      }
    }

  },
  getColor: function() {

    var url = (url_teste == "") ? window.location.href : url_teste;

    if (url.includes("app.royalpag.com")) {
      
     return {
        'background': "#224c85 !important",
        'border-color': "#224c85 !important"
      }
    } 
    else if (url.includes("royalsportbank.royalpag.com")) {

      return {
        'background': "#675fff !important",
        'border-color': "#675fff !important"
      }
    } 
    else if (url.includes("gestaodebanca.royalpag.com")) {

      return {
        'background': "#509de0 !important",
        'border-color': "#509de0 !important"
      }
    } 
    else if (url.includes("reglifecreditos.royalpag.com")) {

      return {
        'color' : "#777 !important",
        'background-color' : "#3d3d3d !important",
        'background': "#ffc700 !important",
        'border-color': "#ffc700 !important",
      }
    } 
    else {
      
      return {
        'background': "#224c85 !important",
        'border-color': "#224c85 !important"
      }
    }

  },
  getColorMenu: function() {

    var url = (url_teste == "") ? window.location.href : url_teste;
 
     if (url.includes("app.royalpag.com")) {
       
      return {
         'background': "#224c85 !important",
         'border-color': "#224c85 !important"
       }
     } 
     else if (url.includes("royalsportbank.royalpag.com")) {
 
       return {
         'background': "#4a148c !important",
         'border-color': "#4a148c !important"
       }
     } 
     else if (url.includes("gestaodebanca.royalpag.com")) {
 
       return {
        'background': "#224c85 !important",
        'border-color': "#224c85 !important"
       }
     } 
     else if (url.includes("reglifecreditos.royalpag.com")) {
 
      return {
       'color': "#777 !important",
       'border-color': "#ffc700 !important",
       'background-color': "#000 !important",
      }
    } 
    else {
       
       return {
         'background': "#224c85 !important",
         'border-color': "#224c85 !important"
       }
     }
 
   },
iconStyleDefault: function() {

    return {
      display: 'block',
      backgroundImage: "url('/static/img/icon-crown.png')",
      backgroundColor: '#fff',
      borderRadius: '4px',
      padding: '10px 13px 11px 13px',
      height: '39px',
      margin: '9px auto',
      backgroundSize: '30px 18px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }
 
},
iconStyleSport: function() {

  return {

    display: 'block',
    backgroundImage: "url('/static/img/logo-branca-sport.png')",
    backgroundColor: 'transparent',
    backgroundSize: '100%',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    width: '30px',
    height: '55px'
  }

},
iconStyleBanca: function() {

  return {
    display: 'block',
    backgroundImage: "url('/static/img/logo-branca-banca.png')",
    backgroundColor: 'transparent',
    backgroundSize: '100%',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    width: '50px',
    height: '55px'
  }

}

}


// WEBPACK FOOTER //
// ./src/service/site_style.js